<script setup lang="ts">
import SelectionItemComments from '@organisms/offer/selection-items/components/SelectionItemComments.vue';
import SelectionItemHeader from '@organisms/offer/selection-items/components/SelectionItemHeader.vue';
import SelectionItemReview from '@organisms/offer/selection-items/components/SelectionItemReview.vue';
import SelectionItemGallery from '@organisms/offer/selection-items/components/SelectionItemGallery.vue';
import type { SelectionItem, SelectionItemOfficeOffer } from '@models/selectionItem.ts';
import { computed, toRefs } from 'vue';
import type { Url } from '@global-types/url.ts';
import type { SerializedOffer } from '@models/offer.ts';
import { isOfferDisabled } from '@organisms/offer/offer-utils';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { storeToRefs } from 'pinia';
import { useSelectionItemOfferUrl } from '@composables/useSelectionItemOfferUrl.ts';

const props = defineProps<{ selectionItem: SelectionItem }>();

const { selectionItem } = toRefs(props);

const { isMobileOrTablet } = storeToRefs(useScreensizeStore());

const { offerUrl, openOffer } = useSelectionItemOfferUrl(selectionItem);
</script>

<template>
  <div class="selection-item-content">
    <a
      :href="offerUrl"
      :target="isMobileOrTablet ? '_self' : '_blank'"
      class="selection-item-content__header"
      @click="openOffer"
    >
      <SelectionItemHeader :selection-item="selectionItem" />
    </a>

    <div class="selection-item-content__body">
      <SelectionItemGallery
        :selection-item="selectionItem"
        class="selection-item-content__gallery"
      />

      <SelectionItemReview
        :selection-item="selectionItem"
        class="selection-item-content__review"
      />
    </div>

    <SelectionItemComments
      :selection-item="selectionItem"
      class="selection-item-content__comments"
    />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-content {
  padding: rem(16);

  &__header {
    display: block;
    text-decoration: none;
  }

  &__body {
    margin-top: rem(12);
    display: flex;
    flex-direction: column;
    gap: rem(12);
  }

  &__comments {
    margin-top: rem(8);
  }
}

@media screen and (min-width: $breakTablet) {
  .selection-item-content {
    &__body {
      flex-direction: row;
    }

    &__gallery {
      flex: 1;
    }

    &__review {
      flex: 1;
    }
  }
}
</style>
